<p-card styleClass="app-frame ds-beta" role="region" aria-labelledby="declareLicenseForm">
    <p-header>
      <div id="declareLicenseForm" class="p-col-12 ACA_TabRow">
          <section-title [contentKey]="'acc_reg_label_enterLicense'" [admin]="adminMode" [viewId]="detailViewId" [module]="module" ></section-title>
          <h5 class="signup-stepcounter"><strong>Step 1 of 3: Your Current License</strong></h5>
          <summary i18n="Please select the type of professional license you hold | License Registration Instructions">Please select the type of professional license you hold. 
            If you have more than one license, select the one you consider primary.</summary>
      </div>
    </p-header>
    <form [formGroup]="licenseForm" (ngSubmit)="submit(licenseForm.value)" class="cardContent">   
        <fieldset #accelaControlDiv id="licenseTypeDiv" class="accelaControl component-content hideFieldset" >
            <legend>
              <label for="licenseTypeDiv" [attr.data-required]="true"><strong i18n="Which License Do You Hold | License Type Label">Which License Do You Hold?</strong></label>
            </legend>
              <div class="p-mt-4"></div>
              <div *ngFor="let opt of this.licenseTypes; let idx=index">
                <p-radioButton [value]="opt.Value" formControlName="licenseType" [ariaLabel]="opt.Key" [label]="opt.Key" [disabled]="this.adminMode || processing"></p-radioButton>
                <div class="p-mb-2"></div>
              </div>
          </fieldset>
          <div *ngIf="!this.adminMode" class="validationFeedback">
              <small *ngIf="licTypeControLRef?.errors?.required && (licTypeControLRef?.touched || licTypeControLRef?.dirty)" class="ng-invalid p-invalid">
                <icon class="accelicons accelicons-alert2  p-mr-1"></icon>
                <span i18n="Please Select a License Type | License Type Required Validation">Please Select a License Type</span>
              </small>
          </div> 
        <div *ngIf="licTypeControLRef?.value !== ''">
          <div #accelaControlDiv id="licenseNumberDiv" class="textinput accelaControl" [formGroup]="this.licenseForm">
            <input name="licenseNumber" id="licenseNumber" type="text" [attr.aria-label]="this.getInputLabel()" attr.aria-required="true" required="true"                
                pInputText formControlName="licenseNumber">
            <label for="licenseNumber" id="licenseNumberLabel" attr.data-required="true" >{{this.getInputLabel()}}</label>
          </div>
          <div *ngIf="!adminMode" class="validationFeedback">
              <small *ngIf="licNumberControLRef.errors?.required && (licNumberControLRef?.touched || licNumberControLRef?.dirty)"
                  class="ng-invalid p-invalid"><icon class="accelicons accelicons-alert2  p-mr-1"></icon>
                  <span i18n="Please Enter a License Number | License Number Required Validation">Please Enter A License Number</span>
              </small>
          </div>
        </div>
        <div *ngIf="!adminMode && licenseNotFound && !licenseForm.dirty" class="validationFeedback p-mb-4">
            <small class="ng-invalid p-invalid"><icon class="accelicons accelicons-alert2 p-mr-1"></icon>
                <span i18n="License number not found | License not found Error">License number not found.</span>
            </small>
        </div>
            <!-- <aca-form-debugger [form]="licenseForm"></aca-form-debugger> -->
      </form>
      <accela-button-primary i18n-label label="Continue" (click)="this.submit($event)" [disabled]="this.adminMode || processing"></accela-button-primary>
      <hr class="separator p-mt-4 p-mb-4" />
      <accela-button-secondary i18n-label label="Back" (click)="this.back()" accessButton="b" [disabled]="this.adminMode || processing" pRipple></accela-button-secondary>
  </p-card>
  